import {
  Avatar,
  Button,
  Card,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
const ChangeLog = () => {
  return (
    <Typography sx={{ fontFamily: 'poppins' }}>
      Welcome to ChangeLog page
    </Typography>
  );
};
export default ChangeLog;
